import Image from '@tiptap/extension-image'
import { mergeAttributes } from '@tiptap/core'

export default Image.extend({
    name: 'custom-image',
    draggable: false,

    addOptions() {
        return {
            ...Image.options,
            sizes: ['small', 'medium', 'large']
        }
        
    },

    commands(_ref) {
        let type = _ref.type;
        return function(attrs) {
          return function(state, dispatch) {
            let selection = state.selection;
            let position = selection.$cursor
              ? selection.$cursor.pos
              : selection.$to.pos;
            let node = type.create(attrs);
            let transaction = state.tr.insert(position, node);
            dispatch(transaction);
          };
        };
      },

    addAttributes() {
        return {
            ...Image.config.addAttributes(),
            size: {
                default: 'large',
                rendered: true
            },
            path: {
                default: null,
                rendered: true
            },
            style: {
                default: null,
                rendered: true
            }
        }
    },

    addCommands() {
        return {
            /*setImage: (options) => ({ commands }) => {
                return commands.insertContent({
                    type: this.name,
                    attrs: options
                })
            },*/
            setImage: (options) => ({ tr, dispatch }) => {
                const { selection } = tr
                const node = this.type.create(options)

                if (dispatch) {
                    tr.replaceRangeWith(selection.from, selection.to, node)
                }

                return true
            },
            setAttributes: (attributes) => ({ tr, dispatch }) => {
                // Check it's a valid size option
                if (!this.options.sizes.includes(attributes.size)) {
                    return false
                }
                const { selection } = tr
                const options = {
                    ...selection.node.attrs,
                    ...attributes
                }
                const node = this.type.create(options)

                if (dispatch) {
                    tr.replaceRangeWith(selection.from, selection.to, node)
                }
            } 
        }
    },

    renderHTML({ node, HTMLAttributes }) {
        const size = node.attrs.size
        HTMLAttributes.class = 'custom-image ' + size

        return [
            'img',
            mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)
        ]
    }
})